import { orchestrator } from 'satcheljs';
import {
    lazyShowFullComposeInEditMode,
    lazyShowQuickCompose,
} from 'owa-calendar-compose-form-store';
import EventScope from 'owa-service/lib/contract/EventScope';
import { lazyShouldAddinsForceOnSendCompliantBehavior } from 'owa-addins-core';
import {
    FULL_COMPOSE_ENTRY_SOURCE_BLOCK_ON_SEND,
    QuickComposeEntrySourceType,
} from 'owa-calendar-helpers-types/lib/ComposeMetricTypes';
import { FULL_COMPOSE_VIEW_TYPE_MODAL } from 'owa-calendar-helpers-types/lib/ComposeTypes';
import { tryShowQuickCompose } from 'owa-calendar-quick-compose/lib/actions/tryShowQuickCompose';

// TODO: VSO #88707 Separate module vs surface concerns in Calendar module
// Quick compose orchestrator should not know about specific entrySource scenarios
// and should live in a compose-related package

export default orchestrator(tryShowQuickCompose, async actionMessage => {
    const { event, entrySource, eventScope, anchor } = actionMessage;

    // If the blockOnSend policy is enabled & an onSend Addin is present, disable the QuickCompose window.
    // Launch fullCompose window instead
    // We also launch FullCompose directly for FTDF flows as these scenarios have some special logic which requires
    // to be run before opening the compose form eg: CollabSpace copy operation.
    const shouldAddinsForceFullCompose = await lazyShouldAddinsForceOnSendCompliantBehavior.import();
    if (shouldAddinsForceFullCompose() || eventScope === EventScope.ThisAndFollowingInstances) {
        lazyShowFullComposeInEditMode.importAndExecute(
            event,
            eventScope,
            false /* itemHasUpdates */,
            FULL_COMPOSE_ENTRY_SOURCE_BLOCK_ON_SEND,
            FULL_COMPOSE_VIEW_TYPE_MODAL,
            null /* extractionSourceId */
        );
        return;
    }
    lazyShowQuickCompose.importAndExecute(
        anchor,
        entrySource as QuickComposeEntrySourceType,
        entrySource == 'CalendarAssetNewEventButton'
            ? 'CalendarAssetNewEventButton'
            : 'Surface' /* viewType */,
        event,
        eventScope
    );
});
